export enum EnumInvoiceStatus{
    Submitted="submitted",
    ProceedToFinance="proceedToFinance",
    MissingInvoice="missingInvoice",
}